export enum ChangeCause {
    MODEL_CHANGE_AFTER_CONSTRUCTOR,
    VALUE_CHANGE_AFTER_SET_FUNCTION_CALL,
    VALUE_CHANGE_AFTER_KEY_DOWN,
    VALUE_CHANGE_AFTER_SELECTABLE_OPTION_SELECTION,
    VALUE_CHANGE_AFTER_DATE_SELECTION_FROM_PICKER,
    VALUE_CHANGE_AFTER_FILE_SELECTION,
    VALUE_CHANGE_AFTER_TOGGLE,
    VALUE_CHANGE_AFTER_NUMBER_PICKER_CLICK,
    FOCUS_CHANGE,
    VALIDATION_ACTIVATION,
    FILTER_MODE_CHANGE,
    READ_ONLY_CHANGE,
    REQUIRED_CHANGE,
    HIDDEN_CHANGE,
    EDIT_MODE_CHANGE
}
